export default function useAdminOrderDisplay({ areas, areaNameMap }) {
  const isOrderIncomplete = (order) => {
    const missingFields = [];
    if (!order.pickup_location || order.pickup_location.trim() === "") {
      missingFields.push("pickup_location");
    }
    if (!order.destination || order.destination.trim() === "") {
      missingFields.push("destination");
    }
    if (!order.pickup_time || order.pickup_time.trim() === "") {
      missingFields.push("pickup_time");
    }
    if (!order.customer_name || order.customer_name.trim() === "") {
      missingFields.push("customer_name");
    }
    return missingFields.length > 0 ? missingFields : null;
  };

  const formatPickupDisplay = (order) => {
    if (!order) return "";

    const areaName = order.pickup_area ? (areaNameMap[order.pickup_area] || order.pickup_area) : "";
    let detail = order.pickup_location_detail || "";

    if (!detail && order.pickup_location) {
      const terminalMatch = order.pickup_location.match(/(T[123]|Terminal\s*[123]|第[123]航站楼)/i);
      if (terminalMatch) {
        detail = terminalMatch[0];
      }
    }

    if (areaName && detail) {
      return `${areaName} ${detail}`;
    }

    return areaName || order.pickup_location || "-";
  };

  const formatDestinationDisplay = (order) => {
    if (!order) return "";

    const areaName = order.dropoff_area ? (areaNameMap[order.dropoff_area] || order.dropoff_area) : "";
    let detail = order.dropoff_location_detail || "";

    if (!detail && order.destination) {
      const terminalMatch = order.destination.match(/(T[123]|Terminal\s*[123]|第[123]航站楼)/i);
      if (terminalMatch) {
        detail = terminalMatch[0];
      }
    }

    if (areaName && detail) {
      return `${areaName} ${detail}`;
    }

    return areaName || order.destination || "-";
  };

  const isKansaiRegion = (areaCode) => {
    if (!areaCode) return false;
    const area = areas.find((item) => item.code === areaCode);
    if (!area) return false;

    const allowedBases = area.allowed_bases;
    if (allowedBases && allowedBases.includes("osaka")) return true;

    const ruleGroup = area.rule_group || "";
    return ruleGroup.includes("kansai") || ruleGroup.includes("osaka");
  };

  const getAvailableVehicleTypes = (areaCode) => {
    if (isKansaiRegion(areaCode)) {
      return [
        { value: "alphard", label: "アルファード" },
        { value: "hiace", label: "ハイエース" },
        { value: "premium_hiace", label: "プレミアムハイエース" },
        { value: "coaster", label: "コースター" },
        { value: "bus", label: "バス" },
        { value: "hiace_14_seats", label: "14座ハイエース" },
      ];
    }
    return [
      { value: "alphard", label: "アルファード" },
      { value: "hiace", label: "ハイエース" },
      { value: "premium_hiace", label: "プレミアムハイエース" },
      { value: "coaster", label: "コースター" },
      { value: "bus", label: "バス" },
      { value: "hiace_14_seats", label: "14座ハイエース" },
    ];
  };

  return {
    formatDestinationDisplay,
    formatPickupDisplay,
    getAvailableVehicleTypes,
    isKansaiRegion,
    isOrderIncomplete,
  };
}
